import React from "react";
import "../styles/splashScreen.css";
import { Box, Container } from "@mui/material";
// import { ReactComponent as NewLogo } from "assets/icons/new_logo.svg";
import { ReactComponent as NewLogo } from "assets/icons/Binnys Chakra.svg";

const SplashScreen = ({ logoUp }) => {
  return (
    <>
      <Container maxWidth="xl">
        <Box className={logoUp ? `logo-up` : `logo`}>
          <NewLogo />
        </Box>
      </Container>
    </>
  );
};

export default SplashScreen;
